export default __webpack_public_path__ + "static/media/upworkFeedback.35fa42ef.png";